module.exports = __webpack_public_path__ + "static/media/incorrect-counter.7c213492.svg";